import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Button, Box, IconButton, Badge, Drawer, List, ListItem, ListItemText, useTheme, useMediaQuery } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { styled } from '@mui/system';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MenuIcon from '@mui/icons-material/Menu';
import cart from '../Cart';
import User from '../data/User';

const Navbar = styled(AppBar)({
  backgroundColor: '#fff',
  color: '#000',
  boxShadow: 'none',
  padding: '10px 0',
  position: 'fixed',
  top: 0,
  width: '100%',
  zIndex: 1000,
});

const LogoContainer = styled(Box)({
  textAlign: 'center',
  marginBottom: '10px',
});

const Logo = styled('img')({
  height: 80,
});

const NavLinks = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '20px',
  width: '100%',
});

const LinkButton = styled(Button)({
  color: '#000',
  textTransform: 'none',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: '#de4d86',
    cursor: 'pointer',
  },
  padding: '10px 20px',
  margin: '0 10px',
});

// const SocialIconButton removed

const Header = () => {
  const [userEmail, setUserEmail] = useState('');
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const checkAuth = async () => {
      if (User.instance.getToken()) {
        await User.instance.fetchData();
        setUserEmail(User.instance.email || '');
      } else {
        setUserEmail('');
      }
    };
    checkAuth();
  }, [location]);

  const signOut = () => {
    User.instance.signOut()
    setUserEmail('')
    window.location.reload()
  }

  return (
    <Navbar>
      <Toolbar style={{ justifyContent: 'center' }}>
        <LogoContainer sx={{ mb: isMobile ? 0 : '10px' }}>
          <Logo src="/logo.png" alt="Logo" sx={{ height: isMobile ? 50 : 80 }} />
        </LogoContainer>
        {isMobile ? (
          <>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton component={Link} to="/cart" color="inherit" sx={{ mr: 1, color: '#000' }}>
              <Badge badgeContent={cart.getItems().length} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ color: '#000' }}
            >
              <MenuIcon />
            </IconButton>

            <Drawer
              anchor="right"
              open={mobileOpen}
              onClose={handleDrawerToggle}
            >
              <Box
                sx={{ width: 250, display: 'flex', flexDirection: 'column', pt: 2 }}
                role="presentation"
                onClick={handleDrawerToggle}
                onKeyDown={handleDrawerToggle}
              >
                <List>
                  <ListItem button component={Link} to="/">
                    <ListItemText primary="Home" />
                  </ListItem>
                  <ListItem button component={Link} to="/about">
                    <ListItemText primary="About" />
                  </ListItem>
                  <ListItem button component={Link} to="/menu">
                    <ListItemText primary="Menu" />
                  </ListItem>
                  {userEmail ? (
                    <>
                      <ListItem button component={Link} to="/profile">
                        <ListItemText primary={userEmail} />
                      </ListItem>
                      <ListItem button onClick={signOut}>
                        <ListItemText primary="Sign Out" />
                      </ListItem>
                    </>
                  ) : (
                    <ListItem button component={Link} to="/login">
                      <ListItemText primary="Login" />
                    </ListItem>
                  )}
                </List>
              </Box>
            </Drawer>
          </>
        ) : (
          <NavLinks>
            <LinkButton component={Link} to="/">Home</LinkButton>
            <LinkButton component={Link} to="/about">About</LinkButton>
            <LinkButton component={Link} to="/menu">Menu</LinkButton>
            {/* <LinkButton component={Link} to="/CustomizeCake"> Customize Cake</LinkButton> */}
            {/* <LinkButton component={Link} to="/contact">Contact Us</LinkButton> */}
            {
              userEmail && (
                <LinkButton component={Link} to="/profile">
                  {userEmail}
                </LinkButton>
              )
            }
            {
              userEmail && (
                <Button onClick={signOut}>
                  Sign Out
                </Button>
              )
            }
            {
              !userEmail && (
                <LinkButton component={Link} to="/login">
                  Login
                </LinkButton>
              )
            }
            <IconButton component={Link} to="/cart" color="inherit">
              <Badge badgeContent={cart.getItems().length} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </NavLinks>
        )}
      </Toolbar>
    </Navbar>
  );
};

export default Header;
